var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47 10.9v13.5c0 3.5-7.2 4.7-7.2 4.7s-7.2-1.2-7.2-4.8V11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f8f22",
    d: "M47 24.4c0 3.5-7.2 4.7-7.2 4.7s-7.2-1.2-7.2-4.8l.1-.4q-.1.2.4 1s-.3-.6 0-1.2c0 0-.1.8.4 1.2 0 0-.3-.6 0-1.4 0 0-.1 1.2.4 1.5 0 0 .2-.7 0-1.1q.1-.2.3 1.1l.1-.9s0 .9.3 1v-.4q-.1-.5.1-.5l.3.7s-.2-.6 0-.7q-.1.2.4.7v-.8s0 .5.3.6v-.6s0 .5.4.6q-.2 0-.2-.6h2.4l1.3.1 3.7-.2.6-.6s.3.4-.1 1q.2.1.5-.8.2.1 0 .8.2-.1.4-1 .2.1-.2 1 .2.1.5-.7.1.1-.2.8s.7-.3.7-1q.2 0 0 1l.3-.9q.2 0 0 .8.2-.1.5-.8l-.3.9.5-.6-.2.6.4-.5v.5l.2-.6v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43.3 16.6h-.6q-.4-.3-.5 0L42 16v.4h-.2l-.2-.2.2-.4q0-.3-.3-.3v.2s-.3-.2.1-.4q.5-.3.3-.5l-.3-.3v.3h-.1v-.4q.1.1.5-.2.2-.2-.4-.6l.1.3q0 .1-.2 0l-.2-.3s.4 0 .3-.4c0 0 0 .3-.6-.1 0 0 .4-.4.2-.7h-.4q.2 0 .2-.4h-.4q.2 0-.1-.4l-.3.2-.4-.3-.3.3-.3-.2v.4H39q-.1-.2-.2 0v.4s-.5-.1-.4.2l.2.5s-.3.4-.5 0v.4q.2 0 .1.4l-.3-.2s-.3.4 0 .6h.6s-.1.6-.4.5l.2-.3q-.2 0-.5.3l.3.5s.3 0 0 .3q-.2 0 0 .3l-.3.3h-.3v.3h-.6l-.5.1-.1.2.2.3v.3l1-.3 1-.5h.6l.5.1h.6l.5-.1h.6l.7.3.8.5h.7v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M36 17.3h.5s.2-.4-.2-.5q.2-.1 0-.5 0-.1-.4 0l-.3-.3-.2.3q-.1-.1-.4 0s-.3.3 0 .5h.3l.2-.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.8 16.7.6.3c.2.5-.3.8-.3.8v.3c.7 0 .6.8.6.8l-.2-.2q-.6-.2-1 .7c-.4.6-.2.8-.2 1.5s1.1 1 1.1 1l-.8 2c-.3.9-1 .6-1.2.4q-.2-.2-.3 0c-.1 0 .4.5-.6.9s-1.1.7-1.3.8h-.9q0-.2-.3-.3l-1.1-.5q-.6-.5-.4-.6s.1-.6-.4-.2-1-.2-1-.2L35 22l.4-.2q.6-.4.7-1 .2-.8 0-1.1-.1-.5-.7-1-.7.1-.7.3s0-.8.6-.8v-.3s-.5-.3-.2-.8c0 0 .1-.4.5-.3v.2s-.2 1 1.4.3 1.5-.8 2.4-.4h.6s1-.4 1.2-.2l1.4.8s1 .3 1.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m39.2 21.3-.2-.6.1-.6.3-.2.3-.2h.2c0-.1.2-.5.7 0l.4-.4.4.1s.3-.2.5.2q.1-.2.6.2.1-.2.6.1l.1.5.2.6.5.7-1.2.4H42l-1.2.3-2 .2-.5-.7.8-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m37.4 24.6-.4.1q-.2 0-.5.3h-.4s-.6-.1-.6.4c0 0-.7 0-.4.7 0 0 .2.5.6.1 0 0-.3.4.2.5q.2.1.5-.3v-.3l.2-.2s-.4.5 0 .7c0 0 .6 0 .6-.5l.2-.3.6-.6s-.6-.3-.6-.6Zm-1.2-4.8h-1.3l-.5.5q-.1-.1-.1.5v.4l-.3.3s-.3.3-.5 0c0 0 0 .4.5.3v.6l-.1.7s.4-.2.4-.6V22l.2.6q.2 0 0 .6s.4-.2.4-.6c0-.5-.3-.3-.2-.7l.2.3.2.6.2-.6-.1-.3.6-.4.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m35.2 21.6-.4-.2m-.5-.2.2.1.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m35.6 20.8-.3-.1q-.2.1 0 .2.2 0-.1.3.2 0 .2-.3l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.1 21.6h.2l-1.2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.3 26h-.5.2s0-.4.3-.3l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M35.3 26.7s-.4-.3-.2-.8h.2s.3 0 0 .4zm.9.4s-.6-.3-.4-.8l.2-.1.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m36 25.3-.2.2-.2-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M36.6 27s.5-.1.4-.7l-.2-.1q-.2 0-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m38.8 16.4.5.2h1l.4-.2-.3.4v.3l.2.2-.4-.1s-.4-.3-.8 0l-.5.1.3-.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.8 26.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43.5 17.3H43s-.2-.4.2-.5q-.2-.1 0-.5 0-.1.4 0l.3-.3.3.3q0-.1.4 0 .2.1-.1.5h-.3l-.2-.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M40.7 17v.1h-.2l.2-.4h.6l1.2.7.7.2q.2.1.8-.4v-.5h-.4v.3l.2-.1v.2s-.4.5-1.3 0l-1.2-.7s-.5-.3-1 .2c0 0-.2.4.2.7q.1.1.4-.1.2-.1 0-.4l-.3.1q0 .4.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e4cb5e",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M36 19.1v-.7l.1-.2q0-.2.3.1l.4-.3h.2l.3-.2s.3-.2.3.3l.2-.2h.3l.4.5v.2l.1.2.2.1.3.3.1.9v1.8L38 23.3l-1.9-.6-.8-.3-.1-.5.7-.5.4-1.1-.1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.3 20h.1l.2-.3.4 1.1v.3s.5.1.6.9l-.5.7-.6-.3-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.2 26q-.2 0 0 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M37.1 25.9v-.3m.5-7.5v.3l.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42 24.6.5.1q.3 0 .5.3h.4s.6-.1.6.4c0 0 .8 0 .5.7 0 0-.2.5-.6.1 0 0 .2.4-.3.5q-.2.1-.5-.3l.1-.3-.3-.2s.4.5 0 .7c0 0-.5 0-.6-.5l-.1-.3q-.2 0-.7-.6s.6-.3.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m37.3 19 .5 4m-.4-4 .6 3.7m-.5-3.8.7 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.6 22.3h.1l-1.1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m37.9 18.8 1.2 3m-1.3-3L39 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36 26.8-.1-.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m38 18.7 1.1 2.7M37.7 19l.8 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M43.7 21.6c-.6-.3-.7-1-.7-1l.2-1.2c.3-.7.9-.8.9-.8s-.6.4-.7 1l-.1.8c0 .5 0 .4.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m41.4 19.9-2.2.7-.1 1c-.6.8-1.6.9-1.6.9l.8.9 1.6.3.8-.6.8-.7V21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m39 21.4 2.4-.9m-3 1.7s1.8-.3 3-1l.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m42 21-.5.4s-2 1-3.6 1m3.6-.3s-1.6.8-2.5.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43.3 19.8h1.3l.6.5v.9l.3.3s.3.3.5 0c0 0 0 .4-.5.3q.2 0 0 .6l.1.7q-.2 0-.3-.6l-.1-.5-.2.6v.6s-.4-.2-.3-.6c0-.5.2-.3 0-.7v.3l-.2.6q-.2 0-.2-.6V22l-.6-.4-.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M35.4 22.4q0-.2.3-.2s.1-.5.7-.6.6.6.6.6l.4-.2s.4 0 .3.7v.1s.4-.8 1.1-.6c0 0 .7.2.3.9q0 .2.6.4.5 0 .8-.6.8-.7 1.2-.6t.3.3s.4-1.2 1.7-1l.5.2.2.1-.3.8-.7 1.6-.6.2-.5-.3H42v.6l-.8.5-.5.2-.6.4-.1.4h-.7V26l-.4-.4-1.3-.6-.2-.7-.3-.1-.2.3h-.4l-.6-.4-.6-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M41 16.5s-.5 0-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M44.3 22c-.9-.3-1.1-1.2-1.1-1.2v-1.3c.5-1 1.1-1 1.1-1a.3.3 0 0 1 .4.3l-.1.3h-.4v-.3h.2v.1-.1q0-.2-.6.3-.2.1-.4 1.1s0 1.3 1.2 1.6l-.4 1-.5 1.4s-.4.7-1.2.4q-.2 0-.4-.6 0-.2.2-.3l.3.2q0 .2-.3.2V24q.2 0 0 0v.1h.1l.3.3.5-.1.3-.4.4-1.1.3-.8Zm-2.5 2.3.2.1-.3.2q-.1.1-.1-.4l.3-.1.3.3v.5l-.8.5-.9.4q-.2.1-.2.5h.2-.1v-.2h.3v.3l-.2.1h-.3q-.3-.4 0-.7l.4-.3.7-.3.6-.4.1-.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m41.9 24.3.2.2.1.2m0-.8v.3q0 .4.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M38.8 17v.1h.2l-.1-.4h-.7l-.5.4-.7.3-.6.2s-.6 0-.8-.4q-.2-.1 0-.5h.3v.3l-.2-.1v.3s.4.4 1.3 0l1.2-.7s.6-.4 1 .1q.2.1-.1.7-.1.2-.5-.1-.1-.1.1-.4l.3.1q-.1.4-.2.1Zm-3 4.6c.6-.3.7-1 .7-1l-.1-1.2c-.4-.7-1-.8-1-.8s.6.4.8 1v.8l-.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M38.5 16.5s.5 0 .5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M35.3 22c.8-.3 1-1.2 1-1.2q.2-.8 0-1.3c-.4-1-1-1-1-1a.3.3 0 0 0-.5.3l.1.3h.4v-.3h-.1l-.1.1v-.1q.1-.2.7.3.2.1.4 1.1s0 1.3-1.3 1.6l.4 1 .6 1.4s.3.7 1.1.4c0 0 .5-.2.5-.6q0-.2-.3-.3l-.3.2q0 .2.3.2l.1-.1h-.1q-.2 0 0 0h.1v.1H37l-.2.3-.6-.1-.3-.4-.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m37.7 24.3-.2.1.3.2q.3.1.2-.4l-.3-.1-.4.3.1.5.7.5 1 .4q.2.1.1.5H39h.2v-.2h-.3l-.1.3.3.1h.2q.3-.4 0-.7l-.3-.3-.8-.3-.5-.4-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m37.7 24.3-.3.2v.2m-.1-.8q.2 0 0 .3l-.2.4m2.2-7.6s.5-.3 1 0m-3.4 2.6-.2-.7-.3-.6m.6-.3.2.6.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m37.1 19.9.1.4m-.6-.6.1.5.3.6m-.5 0s.6 0 .6.4q0 .2.2.3l.4.3m-1-.6.2.3m.5-.6.2.3m.4-2.9.3.3m.3.8q.2-.2.2.8v.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m37.3 18.9.8-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m39 21.5 2.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.9 18.4.8-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "m39 18.3.5 2.8m-.5-2.8.7 2.8m-.5-2.8.7 2.7m-.5-2.8 1 2m-.8-2 1 2m-1-2.1 1.2 2m-1.3 1h.4m-.7-.2 2.2-.8m-2.3.9 2.3-.7m-1.8 2 .1.3h.2v-.4m.4 0v.2h.3l-.1-.3m-1.3-1.5v-.4l2-.6.2.3M40 20l.2.4m.6-.5.1.3m0-.4.2.3m0-.4.2.3m0-.3.2-.1.1.2m-.2-.2.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M36.1 23.6s-.4-.4 0-.8q-.2 0-.4-.6m1.2 1.7s-.5 0-.3-.8l-.3.5a.4.4 0 0 0 .2.5s.5.1.6-.1m-.7-1.4v.5m.2-.4.1.4m0-.5.2.5m0-.7.2.7m1.1 0s.1-.4.4-.4v.2q-.1.1.1.3l.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M39 24.4s-.8-.3-.7-.8l.3-.5m-.2.3.1.4m.1-.5v.4m.2-.5v.4m-.7.9.7.3m-.8-.2.6.3m-.8-.2.8.4m1.1.4s-.4.2 0 .5m-.3-.8.8-.4m-.6.6 1-.6m-.6.6 1-.6m-.6.6 1-.6m0-.4s-.2-.4-.9 0l.8-.5m.7-1.3v.4m-1.1.8.5-.3.4.2s.4-.1.3-.6q.1-.2-.6-.4m1.5-.6s.5.1.5.5c0 0 0 .6-.6.8m.5-1 .5-.5m-.4-.2.3.3m-.3 0 .1.1m-.2 0 .1.1m-2.7-2.6h.3m1 1.3s.2-.7.7-.4m-.2-.1v-.5m-.4.5v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M43.4 27s.6-.2.4-.7l-.2-.1q-.2 0-.2.3v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.6 26.8v-.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M44.2 26.7s.5-.3.2-.8h-.2q-.1-.1 0 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.3 26q.1 0 0 .4.2 0 0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M43 27s-.6-.1-.5-.7l.3-.1q.3 0 0 .3l.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.7 26.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.3 26h.5-.2s-.1-.4-.4-.3l.3.2zm.2-.7.2.2.2-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M42.4 25.9v-.3m2-4 .3-.2m.5-.2-.2.1-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m44 20.8.2-.1h.1v.2q-.2 0 0 .3-.2 0-.1-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M44.2 17.1v-.3q0-.4.3-.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.3 17v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m44 17-.1-.3q-.2-.3 0-.3l.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44 16.8-.1-.3.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m43.8 17-.3-.2q-.2-.2 0-.4l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m43.7 16.8-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M44 17h-.4q-.4-.2-.3.1l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.4 17.1h.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m43.6 16.2.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M44.2 16.3v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M35.4 17.1v-.3q-.1-.4-.4-.3v.3q0 .2.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.3 17v-.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m35.4 17 .2-.3q.2-.3 0-.3l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.5 16.8.1-.3-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m35.7 17 .3-.2q.2-.2 0-.4l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.8 16.8.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M35.5 17h.4q.4-.2.3.1l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.1 17.1h-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m36 16.2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M35.4 16.3v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.9 14.8v.4l.1.3.2-.2q.2 0-.1.6h-.4v-.5l-.1-.5v.5s0 .5.4.4l.2-.3H41v-.7m-.4.8q.1.2-.4.5v-.6.6c-.1 0 .5 0 .4-.5m-.5-.4V15l-.1-.3v.5l-.3-.2q-.2-.4-.3-.3l.2.3q.1.3.5.3m-.9-.6.1.4-.3-.3-.1.4-.4-.2.3.1q0-.2.3-.3l.2.2zm.4-.4.3.1.3-.1-.3.2-.2-.2m-1 1.5.1.2h.2l.2-.2-.2.2h-.2zm1.3-2.4q-.2.1 0 .2-.1.4-.5.3v-.3q-.2 0 0 .3t.5 0q.4.2.6 0t0-.3v.3q-.5.1-.5-.3.2-.1 0-.2m.2-.4v.4zm-.8.4-.2-.2zm1.3 0 .2-.2zm-1.6.3.2-.1zm-.5-1.1.4.2-.2.1v-.1zm2.7 0-.3.2.2.1-.1-.1zm-1.2.2.3-.1h.4-.4q0 .2-.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40 12.8.5-.2q.1.2-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    d: "M40.3 12.8v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.2 12.4.4.1h.3l.3-.2-.4.2V12l-.2.2.1.2zm.6 1.5q-.2.1 0 .1.1 0 0-.2m0-1.1-.4-.1H39h.4q0 .2.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.6 12.8-.5-.2q-.1.2.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    d: "M39.3 12.8v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M47 10.9v13.5c0 3.5-7.2 4.7-7.2 4.7s-7.2-1.2-7.2-4.7V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M.3 0H27v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.5 0 10.1 7.5L23.8 0H27v2.6L17 10l10 7.5V20h-3.3l-10-7.5-10 7.5H.3v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H.3zM27 0v.1L16.6 8l.1-1.9L25 0zM.3 0l10 7.3H7.8L.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 0v20H17V0zM.4 6.7v6.6H27V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.3 8v4H27V8zm11.4-8v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBm);
export default __webpack_public_path__ + "static/media/bm.2065232f631a0336f380cbd0dd44c6b4.svg";
export { ForwardRef as ReactComponent };